import { FormControl, InputLabel, MenuItem, Select, SelectProps } from '@mui/material';
import React from 'react';

import { Channel } from 'app/constants/channel';

interface GridChannelEditProps {
    /**
     * Default: channel
     */
    name?: string;
    label?: string;
    value?: Channel;
    autofocus?: boolean;
    onChange?: SelectProps['onChange'];
    emptyLabel?: React.ReactNode;
}

export class ChannelSelector extends React.Component<GridChannelEditProps> {
    public render(): React.ReactNode {
        const emptyLabel = this.props.emptyLabel || '(none)';

        return (
            <FormControl fullWidth>
                {this.props.label ? <InputLabel>{this.props.label}</InputLabel> : ''}
                <Select
                    name={this.props.name || 'channel'}
                    ref={(element) => {
                        if (this.props.autofocus && element instanceof HTMLElement) {
                            element.querySelector<HTMLSelectElement>('div.MuiSelect-select')!.focus();
                        }
                    }}
                    value={this.props.value || Channel.NONE}
                    onChange={this.props.onChange}
                    displayEmpty={undefined === this.props.label}
                    label={this.props.label}
                >
                    <MenuItem value={Channel.NONE}>{emptyLabel}</MenuItem>
                    <MenuItem value={Channel.ONLINE}>Online</MenuItem>
                    <MenuItem value={Channel.BM}>B&M</MenuItem>
                </Select>
            </FormControl>
        );
    }
}
